/**
 * Met en mots le delai d'un 429. Le serveur envoie `Retry-After` en secondes ;
 * afficher « reessaie dans 847 secondes » demande au lecteur de faire la
 * division lui-meme.
 */
export function formatRetryDelay(seconds: number | null): string {
  if (seconds === null || seconds <= 0) return 'quelques minutes';
  if (seconds < 60) return seconds === 1 ? '1 seconde' : `${seconds} secondes`;
  const minutes = Math.ceil(seconds / 60);
  return minutes === 1 ? '1 minute' : `${minutes} minutes`;
}

const CLOCK = new Intl.DateTimeFormat('fr-FR', {
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatClock(epochMs: number): string {
  return CLOCK.format(new Date(epochMs));
}
